import React from 'react';
import PropTypes from 'prop-types';
import MicroFrontend from '../../common/MicroFrontend';

const { REACT_APP_PE_URL_CONTACT_FORM: contactFormHost } = process.env;

const ContactForm = ({
  location,
  containerPath,
  containerState,
  catchError,
}) => {
  const handleCatchError = () => {
    catchError();
  };
  return (
    <MicroFrontend
      name="ContactForm"
      host={contactFormHost}
      location={location}
      containerPath={containerPath}
      containerState={containerState}
      catchError={handleCatchError}
    />
  );
};

ContactForm.propTypes = {
  location: PropTypes.string,
  containerPath: PropTypes.string,
  containerState: PropTypes.string,
  catchError: PropTypes.func,
};

export default ContactForm;
